(() => {
  if (customElements.get('strongest-reels')) return;
  class StrongestReels extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('[data-modal]');
      this.track = this.querySelector('[data-mtrack]');
      this._setupThumbs();
      if (!this.modal || !this.track) return;
      this.slides = [].slice.call(this.track.children);
      this.videos = this.slides.map(function (s) { return s.querySelector('video'); });
      this.index = 0;
      this.muteBtn = this.querySelector('[data-reel-mute]');

      this.querySelectorAll('[data-idx]').forEach((el) => {
        el.addEventListener('click', () => this.open(parseInt(el.dataset.idx, 10) || 0));
        el.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.open(parseInt(el.dataset.idx, 10) || 0); } });
      });
      var close = this.querySelector('[data-reel-close]'); if (close) close.addEventListener('click', () => this.close());
      var prev = this.querySelector('[data-reel-prev]'); if (prev) prev.addEventListener('click', () => this.go(-1));
      var next = this.querySelector('[data-reel-next]'); if (next) next.addEventListener('click', () => this.go(1));
      if (this.muteBtn) this.muteBtn.addEventListener('click', () => this._toggleMute());
      this.modal.addEventListener('click', (e) => { if (e.target === this.modal || e.target === this.modal.firstElementChild) this.close(); });
      this.videos.forEach((v) => { if (v) v.addEventListener('ended', () => this.go(1)); });
      this._onKey = (e) => { if (e.key === 'Escape') this.close(); else if (e.key === 'ArrowDown') this.go(1); else if (e.key === 'ArrowUp') this.go(-1); };

      var sy = 0;
      this.track.addEventListener('touchstart', (e) => { sy = e.touches[0].clientY; }, { passive: true });
      this.track.addEventListener('touchend', (e) => {
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dy) > 50) this.go(dy < 0 ? 1 : -1);
      }, { passive: true });
    }
    _setupThumbs() {
      var thumbs = [].slice.call(this.querySelectorAll('[data-vthumb]'));
      var hover = window.matchMedia && window.matchMedia('(hover:hover)').matches;
      var seekFrame = function (v) {
        v.addEventListener('loadedmetadata', function () { try { v.currentTime = 0.1; } catch (e) {} }, { once: true });
      };
      var reveal = function (v) {
        if (v.dataset.poster) { if (!v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster); }
        else if (!v.getAttribute('poster')) { seekFrame(v); try { v.load(); } catch (e) {} }
      };
      var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var v = en.target; obs.unobserve(v); reveal(v);
        });
      }, { rootMargin: '200px' }) : null;
      thumbs.forEach(function (v) {
        if (io) { io.observe(v); } else { reveal(v); }
        if (hover) {
          var card = v.closest('[data-idx]');
          if (!card) return;
          card.addEventListener('mouseenter', function () { card.classList.add('is-playing'); var p = v.play(); if (p && p.catch) p.catch(function () {}); });
          card.addEventListener('mouseleave', function () { card.classList.remove('is-playing'); try { v.pause(); v.currentTime = 0.1; } catch (e) {} });
        }
      });
    }
    _toggleMute() {
      var v = this.videos[this.index]; if (!v) return;
      v.muted = !v.muted;
      if (this.muteBtn) this.muteBtn.classList.toggle('is-on', !v.muted);
      if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
    open(i) {
      this.index = i;
      this.modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this._onKey);
      this._apply();
    }
    close() {
      this.modal.hidden = true;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this._onKey);
      this.videos.forEach((v) => { if (v) { v.pause(); var s = v.closest('.vd-modal__slide'); if (s) s.classList.remove('is-loading'); } });
    }
    go(dir) {
      var n = this.index + dir;
      if (n < 0) n = this.slides.length - 1;
      if (n >= this.slides.length) n = 0;
      this.index = n;
      this._apply();
    }
    _apply() {
      this.track.style.transform = 'translateY(-' + (this.index * 100) + '%)';
      var self = this;
      this.videos.forEach(function (v, i) {
        if (!v) return;
        var slide = v.closest('.vd-modal__slide');
        if (i === self.index) {
          v.muted = false;
          if (slide) slide.classList.add('is-loading');
          var done = function () { if (slide) slide.classList.remove('is-loading'); };
          v.addEventListener('playing', done, { once: true });
          v.addEventListener('loadeddata', done, { once: true });
          try { v.currentTime = 0; } catch (e) {}
          var p = v.play();
          if (p && p.catch) p.catch(function () { done(); });
        } else {
          try { v.pause(); } catch (e) {}
          if (slide) slide.classList.remove('is-loading');
        }
      });
      if (this.muteBtn) this.muteBtn.classList.toggle('is-on', true);
    }
  }
  customElements.define('strongest-reels', StrongestReels);
})();
